import { bucketSuffix, NovaEnvironment, SupportedRegions } from "@nova/constants"
import { config, currentRegion } from "@nova/configuration"

export const getDataBucket = (region = currentRegion(), environment?: NovaEnvironment) => {
    return `nova-${environment || config.get("environmentName")}-data` + bucketSuffix[region]
}

export const getSampleDataBucket = (region = currentRegion(), environment?: NovaEnvironment) => {
    return `nova-${environment || config.get("environmentName")}-demo-data` + bucketSuffix[region]
}

export const getProjectBucket = (region = currentRegion(), environment?: NovaEnvironment) => {
    return `nova-${environment || config.get("environmentName")}-projects` + bucketSuffix[region]
}

export const getIngestBucket = (region = currentRegion(), environment?: NovaEnvironment) => {
    return `nova-${environment || config.get("environmentName")}-ingest` + bucketSuffix[region]
}

export const getDjiUploadBucket = (region = currentRegion(), environment?: NovaEnvironment) => {
    return `nova-${environment || config.get("environmentName")}-dji-upload` + bucketSuffix[region]
}

export const getProfilerBucket = (region = currentRegion(), environment?: NovaEnvironment) => {
    return `nova-${environment || config.get("environmentName")}-profiler` + bucketSuffix[region]
}

export const getWeatherDataBucket = (environment?: NovaEnvironment) => {
    return (
        `nova-${environment || config.get("environmentName")}-weather-data` +
        bucketSuffix[SupportedRegions.Canada]
    )
}

export const getAirspaceRestrictionsBucket = (environment?: NovaEnvironment) => {
    return (
        `nova-${environment || config.get("environmentName")}-airspace-restrictions` +
        bucketSuffix[SupportedRegions.Canada]
    )
}
